<template>
	<div class="Apply-Slot-Group">
		<ApplySlot @refreshButton="_getApplyButton" @saveData="saveData"  :buttonShowType="buttonShowType" v-for="(item,index) in applySlot" :value="item" :key="index">
			<slot></slot>
		</ApplySlot>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import ApplySlot from '@/components/Apply-Slot'
export default {
	name:  '',
	components: {
		ApplySlot
	},
	// 定义属性
	data() {
		return {
			applySlot: []
		}
	},
	props: {
		buttonShowType: {
			type: Number,
			default: 0
		},
		bids: {
			type: Array,
			default: () => {
				return [-1]
			}
		}
	},
	// 计算属性，会监听依赖属性值随之变化
	computed: {},
	// 监控data中的数据变化
	watch: {},
	// 方法集合
	methods: {
		saveData(_data) {
			this.$emit('saveData',_data)
		},
		_getApplyButton() {
			this.$store.dispatch('getApplyButton',{
				bids: this.bids,
				success: (res) => {
					this.applySlot = res
				},
				fail: () => {
					this.$message.warning('业务审批数据出错')
				}
			})
		}
	},
	// 生命周期 - 创建完成（可以访问当前this实例）
	created() {
		
	},
	// 生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
		this._getApplyButton()
	},
	beforeCreate() {}, // 生命周期 - 创建之前
	beforeMount() {}, // 生命周期 - 挂载之前
	beforeUpdate() {}, // 生命周期 - 更新之前
	updated() {}, // 生命周期 - 更新之后
	beforeDestroy() {}, // 生命周期 - 销毁之前
	destroyed() {}, // 生命周期 - 销毁完成
	activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
	
</style>